import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidEmailError extends Violation {
    public constructor(messageParams: { emails: string }) {
        super(ViolationSeverity.Error, 'business.document.sale.validation.email.message', messageParams);
    }
}
